<template>
  <div id="reportTable">
    <div class="title">
      <h3 style="display: none;">{{ data.full_name }} {{ title }}</h3>
    </div>

    <!-- Compare Table -->

    <div v-if="this.compare.length">
      <table>
        <thead v-bind:style="{ 'background-color':  reportColour}" v-if="home != true"> 
          <tr>
            <template v-if="this.home === true">
              f
            </template>
            <template v-else>
              <th></th>
            </template>
            <th>
              Pos
            </th>
            <th>
              Country
            </th>
            <th>
              Player(S)
            </th>
            <th>
              Par
            </th>
            <template v-if="this.home === false">
              <th v-for="(i, roundIt) in range(1, roundsPlayed)" :key="roundIt">
                <span v-if="roundsPlayed === 1">
                  Score
                </span>
                <span v-else> R{{ i }} </span>
              </th>  
            </template>
            <th v-if="roundsPlayed > 1">
              Score
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(tabledata, index) in compare" :key="index">
            <td></td>
            <td
              class="posnum"
              v-if="
                index !== 0 &&
                  (tabledata.tied !== '=' ||
                    Eds[index - 1].pos !== tabledata.pos)
              "
            >
              <span>
                {{ tabledata.pos }}
              </span>
            </td>
            <td class="posnum" v-else-if="index === 0">
              <span>
                {{ tabledata.pos }}
              </span>
            </td>
            <td v-else class="noPos"><span>.</span></td>
            <td class="mobHide">
              <span>
                <img
                  class="flag"
                  :src="
                    ('https://assets.ocs-sport.com/flags/svg/flag_' +
                      tabledata.nationality)
                      | lowercase
                  "
                />
                {{ tabledata.city }}
              </span>
            </td>
            <td
              :class="{
                'text-up': tabledata.posChang == 'up',
                'text-down': tabledata.posChang == 'down',
              }"
            >
              <a :href="'/playerprofile/' + tabledata.member_no" class="nameLink">
                {{ tabledata.playing_name }}
                <span v-if="tabledata.sponsored === 'Y'"
                  ><b-img
                    class="titleistLogo"
                    src="https://assets.asiantour.com/asian-tour/2018/11/titleist_oom-copy.png"
                  ></b-img
                ></span>
              </a>
            </td>
            <td v-if="tablePick === 'Final'">
              {{ tabledata.winnings }}
            </td>
            <td v-if="tabledata.vspar < 0" class="up">
              {{ tabledata.vspar }}
            </td>
            <td v-else-if="tabledata.vspar > 0" class="down">
              {{ tabledata.vspar }}
            </td>
            <td v-else>
              {{ tabledata.vspar }}
            </td>
            <td v-for="(i, roundIt) in range(1, roundsPlayed)" :key="roundIt">
              <span
                v-if="roundsPlayed === 1 && tabledata.vspar < 0"
                class="up"
                >{{ tabledata.score }}</span
              >
              <span
                v-else-if="roundsPlayed === 1 && tabledata.vspar > 0"
                class="down"
                >{{ tabledata.score }}</span
              >
              <span v-else-if="roundsPlayed === 1">{{ tabledata.score }}</span>
              <span v-else-if="tabledata['vspar_R' + i] < 0" :class="up">{{
                tabledata["score_R" + i]
              }}</span>
              <span v-else-if="tabledata['vspar_R' + i] > 0" :class="down">{{
                tabledata["score_R" + i]
              }}</span>
              <span v-else>{{ tabledata["score_R" + i] }}</span>
            </td>
            <td v-if="tabledata.vspar < 0 && roundsPlayed > 1" class="up">
              {{ tabledata.score }}
            </td>
            <td
              v-else-if="tabledata.vspar > 0 && roundsPlayed > 1"
              class="down"
            >
              {{ tabledata.score }}
            </td>
            <td v-else-if="roundsPlayed > 1">
              {{ tabledata.score }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Reports Table -->
    <table>
      <thead v-bind:style="{ 'background-color':  reportColour}">
        <tr>
          <template v-if="(tablePick === 'Score' && data.match_play === 'N') || (tablePick === 'Live' && data.match_play === 'N')
            "
          >
            <template v-if="this.home === false">
              <th></th>
            </template>
            <th>
              <span class="spanPos">
                Pos
              </span>
            </th>
            <template v-if="this.home === false">
              <th>
                Country
              </th>
            </template>
            <th>
              Name
            </th>
            <template v-if="data.bball_team == 'Y'">
              <th class="PadLeft">
                Par
              </th>
            </template>
            <template v-else>
              <th
                class="PadLeft"
                v-if="
                  data.score_type === 'P' ||
                    (data.tt_type === 'P' && data.stableford === 'N')
                "
              >
                Par
              </th>
            </template>
            <th
              class="PadLeft"
              v-if="
                data.score_type === 'P' ||
                  (data.tt_type === 'P' && data.stableford === 'Y')
              "
            >
              Points
            </th>
            <th
              class="hideOnMob"
              v-if="
                data.scores.scores_entry[0].score_found === 'Y' ||
                  data.scores.scores_entry.score_found === 'Y'"
            >
              <span>
                Score
              </span>
            </th>
            <!-- <template v-if="this.title.includes('Scoreboard')">
              <th
                v-for="(i, roundIt) in range(1, roundsPlayed)"
                :key="roundIt"
                class="hideOnMob"
              >
                <span v-if="roundsPlayed === 1 && tablePick === 'Score'">
                  Score
                </span>
                <span v-else> R{{ i }} </span>
              </th>
              <template v-if="data.scores.scores_entry[0].score_found === 'Y'">
                <th v-if="roundsPlayed > 1">
                  Score
                </th>
              </template>
              <template v-if="roundsPlayed > 1 && tablePick === 'Score'">
                <th
                  class=""
                  v-if="
                    config.VUE_APP_PLAYER_ICON === 'Y' &&
                      data.scores.scores_entry[0].score_found === 'Y' &&
                      data.last_round_complete === 'Y'
                  "
                ></th>
              </template>
            </template> -->
            <template
              v-if="
                data.scores.scores_entry[0].score_found === 'N' ||
                  data.scores.scores_entry.score_found === 'N' ||
                  data.round_head == 'Latest Scores'
              "
            >
              <th>
                Thru
              </th>
            </template>
            <!-- <template
              v-else-if="
                (data.scores.scores_entry[0].score_found === 'Y' &&
                  this.title.includes('Scores Only')) ||
                  this.title.includes('Latest Scores')
              "
            >
              <th>Score</th>
            </template> -->
          </template>
        </tr>
      </thead>
      <tbody>

      <template v-if="(tablePick === 'Score' && data.match_play === 'N') || (tablePick === 'Live' && data.match_play === 'N')">      
        <template v-for="(tabledata, index) in Eds">
          <tr @click.stop="rowClicked(index)" :key="index" :class="{scoreOnlyCheckOrination: mobWidget == 'Y'}">
              <td v-if="tabledata.pos !== 'CUT' && home === false">
                <b-form-checkbox
                  :id="tabledata.member_no"
                  v-model="compare"
                  :name="tabledata.member_no"
                  :value="tabledata"
                >
                </b-form-checkbox>
              </td>
              <td class="cut" colspan="11" v-if="tabledata.pos === 'CUT'">
                {{ tabledata.cut_round }}
              </td>
              <td
                class="posnum scorePos"
                :class="{nsyCSS: tabledata.pos == 'NSY'}"
                v-else-if="
                  index !== 0 &&
                    (tabledata.tied !== '=' ||
                      Eds[index - 1].pos !== tabledata.pos)
                "
              >
                <span>
                  {{ tabledata.pos }}
                </span>
              </td>
              <td class="posnum scorePos" v-else-if="index === 0" :class="{nsyCSS: tabledata.pos == 'NSY'}">
                <span>
                  {{ tabledata.pos }}
                </span>
              </td>
              <td v-else class="posnum scorePos"><span class="novalue" ></span></td>
              <td class="mobHide" v-if="tabledata.pos !== 'CUT' && home === false">
                <span v-if="tabledata.nationality === ''"></span>
                <span class="FlagScores" v-else>
                  <img
                    class="flag"
                    :src="
                      (config.VUE_APP_FLAG_URL + tabledata.nationality)
                        | lowercase
                    "
                  />
                  {{ tabledata.represents }}
                </span>
              </td>
              <td
                v-if="
                  tabledata.playerno !== 'Cat' &&
                    tabledata.pos !== 'CUT' &&
                    team === 'N'
                "
                :class="{
                  'text-up': tabledata.posChang == 'up',
                  'text-down': tabledata.posChang == 'down',
                }"
              >
                  <span class="Pname">
                    {{ tabledata.playing_name }}
                  </span>
                  <span v-if="tabledata.pro_ind == 'Am'" class="amature">(a)</span> 
                  <!-- <span v-if="tabledata.sponsored === 'Y' && home === false"
                    ><b-img class="titleistLogo" :src="'https://wp-ocssport.ocs-sport.com/wp-content/uploads/2024/08/titleist_oom-copy.png'"></b-img
                  ></span> -->
                <span v-if="data.multi_course === 'Y'" class="multiCourseSpan" :class="tabledata['course_colour_R' + pftroundsPlayed]">•</span>
              </td>
              <td
                v-if="
                  tabledata.playerno !== 'Cat' &&
                    tabledata.pos !== 'CUT' &&
                    team === 'Y'
                "
                 @click="playerCard(tabledata.id, (toggle = !toggle))"
                :class="{
                  'text-up': tabledata.posChang == 'up',
                  'text-down': tabledata.posChang == 'down',
                }"
              > 
                <span class="Pname">
                  {{ tabledata.name }}
                </span>
                <span v-if="tabledata.pro_ind == 'Am'" class="amature">(a)</span> 
                <!-- <span v-if="tabledata.sponsored === 'Y'"
                  ><b-img class="titleistLogo" :src="'https://wp-ocssport.ocs-sport.com/wp-content/uploads/2024/08/titleist_oom-copy.png'"></b-img
                ></span> -->
                <span v-if="data.multi_course === 'Y'" class="multiCourseSpanTeam" :class="tabledata['course_colour_R' + pftroundsPlayed]">•</span>
              </td>
              <td v-if="tabledata.vspar < 0" class="up posDown">
                {{ tabledata.vspar }}
              </td>
              <td v-else-if="tabledata.vspar > 0" class="down posDown">
                {{ tabledata.vspar }}
              </td>
              <td class="ParBlack" v-else-if="tabledata.pos !== 'CUT'">
                {{ tabledata.vspar }}
              </td>
              <template v-if="title.includes('Scoreboard') && tabledata.pos !== 'CUT' &&
                    home === false">
                <template v-if="home === false">
                  <td
                    v-for="(i, roundIt) in range(1, roundsPlayed)"
                    :key="roundIt"
                  >
                    <span
                      v-if="roundsPlayed === 1 && tabledata.vspar < 0"
                      class="up posDown"
                      >{{ tabledata.score }}</span
                    >
                    <span
                      v-else-if="roundsPlayed === 1 && tabledata.vspar > 0"
                      class="down posDown"
                      >{{ tabledata.score }}</span
                    >
                    <span class="ParBlack" v-else-if="roundsPlayed === 1">{{
                      tabledata.score
                    }}</span>
                    <span v-else-if="tabledata['vspar_R' + i] < 0" :class="up" class="posDown">{{
                      tabledata["score_R" + i]
                    }}</span>
                    <span
                      class="posDown"
                      v-else-if="tabledata['vspar_R' + i] > 0"
                      :class="down"
                      >{{ tabledata["score_R" + i] }}</span
                    >
                    <span class="posDown" v-else>{{ tabledata["score_R" + i] }}</span>
                  </td>
                </template>
                <template
                  v-if="
                    data.round_head == 'Latest Scores' ||
                      (tabledata.score_found == 'N' && tabledata.pos !== 'CUT')
                  "
                >
                  <td v-if="tabledata.pos !== 'CUT'" style="color: #6c6c6c; font-weight:bold;" :class="{thruColumn : home == false}">
                    <template
                      v-if="tabledata.holes && tabledata.holes.length > 0"
                    >
                      <span class="holeNum" v-show="tabledata.holes != '18'">{{
                        tabledata.holes
                      }}
                        <span v-if="tabledata['tee_R' + data.pft_round] > 1"
                          >*</span
                        >
                      </span>
                      <span class="holeNum" v-show="tabledata.holes == '18'">F</span>
                    </template>
                    <template v-else>
                      <span class="teeNum" v-if="tabledata['score_R' + data.pft_round] == '' || tabledata['score_R' + data.pft_round] == 'RTD' && tabledata['score_R' + data.pft_round] == 'WDN' && tabledata['score_R' + data.pft_round] == 'DSQ'">
                        {{ tabledata["time_R" + data.pft_round] }}
                      </span>
                    </template>
                  </td>
                </template>
                <template v-else>
                  <td v-if="tabledata.vspar < 0 && roundsPlayed > 1" class="up posDown">
                    {{ tabledata.score }} 
                  </td>
                  <td
                    v-else-if="tabledata.vspar > 0 && roundsPlayed > 1"
                    class="down posDown"
                  >
                    {{ tabledata.score }}
                  </td>
                  <td v-else-if="roundsPlayed > 1" class="ParBlack">
                    {{ tabledata.score }}
                  </td>
                  <td ></td>
                </template>
              </template>
              <template
                v-else
              >
                <template v-if="tabledata.score_found == 'Y'">
                  <td v-if="tabledata.vspar < 0" class="up posDown">
                      {{ tabledata.score }} 
                    </td>
                    <td
                      v-else-if="tabledata.vspar > 0"
                      class="down posDown"
                    >
                      {{ tabledata.score }}
                    </td>
                    <td v-else class="ParBlack">
                      {{ tabledata.score }}
                    </td>
                </template>
                <template v-else>
                  <td v-if="tabledata.pos !== 'CUT'" style="color: #6c6c6c; font-weight: bold" >
                    <template
                      v-if="tabledata.holes && tabledata.holes.length > 0"
                    >
                      <span class="holeNum" v-show="tabledata.holes != '18'">{{
                        tabledata.holes
                      }}
                        <span v-if="tabledata['tee_R' + data.pft_round] > 1"
                          >*</span
                        >
                      </span>
                      <span class="holeNum" v-show="tabledata.holes == '18'">F</span>
                    </template>
                    <template v-else-if="tabledata.score_found == 'Y' && data.tt_type != 'P'">
                      <span style="font-weight: bold"> {{ tabledata.score}}</span>
                        <!-- <td v-if="tabledata.vspar < 0 && roundsPlayed > 0" class="up">
                            {{ tabledata.score }}
                        </td>
                        <td
                          v-else-if="tabledata.vspar > 0 && roundsPlayed > 0"
                          class="down"
                        >
                          {{ tabledata.score }}
                        </td>
                        <td v-else-if="roundsPlayed > 0">
                          <span :class="{
                            nonScore: tabledata.vspar == 'RTD',
                            nonScoreone: tabledata.vspar == 'DSQ',
                            nonScoretwo: tabledata.score == 'WDN',
                            nonScorethree: tabledata.score == 'DSQ',
                            nonScorefour: tabledata.score == 'RTD'
                          }">
                            {{ tabledata.score }}
                          </span>
                        </td> -->
                      <!-- {{ tabledata["time_R" + data.pft_round] }} -->
                    </template>
                    <template v-else>
                      <!-- <span v-if="tabledata['score_R' + data.pft_round] == 'RTD' && tabledata['score_R' + data.pft_round] == 'WDN' && tabledata['score_R' + data.pft_round] == 'DSQ'"> -->
                      <span class="teeNum" >  {{ tabledata["time_R" + data.pft_round] }}</span>
                      <!-- </span> -->
                    </template>
                  </td>
                </template>
              </template>
              <td
                v-if="
                  tabledata.playerno !== 'Cat' &&
                    tabledata.playerno !== 'EOF' &&
                    config.VUE_APP_PLAYER_ICON === 'Y'
                "
              >
                <a :href="'/playerprofile/' + tabledata.member_no">
                  <font-awesome-icon
                    style="color:#f2af15!important;"
                    id="user"
                    class="icon"
                    :icon="['fa', 'user']"
                  />
                </a>
              </td>
          </tr>
          <tr
             v-if="index === clickedRow && toggle == true"
            class="tr-kids"
            :key="index + Math.random()"
          >
            <td id="reportCard" colspan="11">
              <PlayerReportCard
                :playerData="playerData"
                :playerDataTeam="playerDataTeam"
                :data="data"
                :config="config"
                :actualRound="data.pft_round"
                :roundsPlayed="data.pft_round"
                :scoreType="data.scores_type"
                :team="team"
                :courses="courses"
                :stablford="data.stableford"
                :rts="data.rts[0]"
              />
            </td>
          </tr>
        </template>
      </template>


      </tbody>
    </table>
  </div>
</template>

<script>
import ads from '@/js/ads.js'

import PlayerReportCard from "@/ocs/playerReportCard.vue";
export default {
  name: "reportTable",
  props: [
    "data",
    "previousData",
    "home",
    "title",
    "season",
    "code",
    "tour",
    "team",
    "config",
    "match",
    "show",
    "multi_tourns"
  ],
  components: { 
    PlayerReportCard,

  },
  data() {
    return {
      compare: [],
      up: "up",
      down: "down",
      scores: [],
      clickedRow: -1,
      cardID: [],
      toggle: "",
      playerCardData: [],
      win: "win",
      ads:ads,
      reportColour: process.env.VUE_APP_REPORT_MAIN_COLOUR,
      mobWidget: process.env.VUE_APP_MOB_WIDGET,
      text:'',
    };
  },
  methods: {
    myFunction: function() {
      
      // let w = window.outerWidth;
      // let txt = "Window size: width=" + w + ", height=" + h;
      let h = window.outerWidth;
      let txt = h;
      this.text = txt;
    },
    range: function(start, end) {
      if (this.roundsPlayed === 1) return this.roundsPlayed;
      else
        return Array(end - start + 1)
          .fill()
          .map((_, idx) => start + idx);
    },
    rowClicked: function(index) {
      if (this.tablePick === "Score" && this.clickedRow !== index)
        this.clickedRow = index;
      else this.clickedRow = -1;
    },
    playerCard: function(playerNo) {
      if (this.toggle == true) {
        this.toggle = true;
        // console.log("this.toggle")
        // console.log(this.toggle)
        var playerData = {};
        // var cardID = event.target.getAttribute("title");
        console.log("playerData");
        console.log(playerData);
        var cardID = playerNo;
        console.log("cardID");
        console.log(cardID);
        for (var i of this.data.scores.scores_entry) {
          console.log("in scores");
          if (i.member_no == playerNo) {
            this.playerData = i;
            // console.log("playerData 998");
            // console.log(this.playerData);
            break;
          }
        }
        for (var t of this.data.team_scores.team_scores_entry) {
          // console.log("in scores");
          if (t.member_no == playerNo) {
            this.playerDataTeam = t;
            // console.log("playerData 998");
            // console.log(this.playerDataTeam);
            break;
          }
        }
      } else {
        this.toggle = false;
        // console.log("this.toggle")
        // console.log(this.toggle)
      }
    },
    getScores: function(x, y) {
      const rowLimit = (this.multi_tourns == 'Y' || this.show == true) ? x : y;
      const reportData = [];

      let rowCount = 0;

      for (const i of this.data.scores.scores_entry) {
        if (rowCount >= rowLimit)
          break;

        if (i.pos != 'CUT' && i.pos != 'EOQ') {
          reportData.push(i);
          rowCount++;
        }
      }

      return reportData;
    }
  },
  computed: {
    tablePick: function(picked) {
      if (this.title.includes("Tournament")) picked = "Entries";
      else if (this.title.includes("Draw")) picked = "Draw";
      else if (
        this.title.includes("Scores") ||
        this.title.includes("Scoreboard")
      )
        picked = "Score";
      else if (this.title.includes("Live")) picked = "Live";
      else if (
        this.title.includes("Final") ||
        this.title.includes("Statistics")
      )
        picked = "Final";
      return picked;
    },
    roundsPlayed() {
      return parseInt(this.data.rounds_played);
    },
    pftroundsPlayed() {
      return parseInt(this.data.pft_round);
    },
    Eds(reportData) {
      const windowWidth = window.innerWidth;
      if (this.home === false) {
        if (this.title.includes("Tournament"))
          reportData = this.data.entries.entries_entry;
        else if (this.title.includes("Draw"))
          reportData = this.data.draw.draw_entry;
        else if (
          (this.title.includes("Scores") && this.team === "N") ||
          (this.title.includes("Scoreboard") && this.team === "N") ||
          (this.title.includes("Live") && this.team === "N")
        )
          reportData = this.data.scores.scores_entry;
        else if (
          (this.title.includes("Scores") && this.team === "Y") ||
          (this.title.includes("Scoreboard") && this.team === "Y") ||
          (this.title.includes("Live") && this.team === "Y")
        )
          reportData = this.data.team_scores.team_scores_entry;
        else if (
          this.title.includes("Final") ||
          this.title.includes("Statistics")
        ) {
          reportData = this.data.result.result_entry;
          // var setOne = allData.slice(0, 5);
          // var setTwo = allData.slice(5, 25);
          // var setThree = allData.slice(25);
          // var addOne = this.ads[0];
          // var addTwo = "Test Two";
          // let comone = setOne.concat(addOne);
          // let comtwo = setTwo.concat(addTwo);
          // let comthree = comone.concat(comtwo);
          // reportData = comthree.concat(setThree);
        }
        return reportData;
     } else {
        if (process.env.VUE_APP_MOB_WIDGET == 'Y') {
            if (this.title === "Tournament Entries")
              reportData = this.data.entries.entries_entry.slice(0, 8);
            else if (this.title.includes("Draw"))
              reportData = this.data.draw.draw_entry.slice(0, 10);
            else if (
              this.title.includes("Scores") ||
              this.title.includes("Scoreboard")
            )
              reportData = this.data.scores.scores_entry.slice(0, 6); 
            else if (
              this.title.includes("Final") ||
              this.title.includes("Statistics")
            )
              reportData = this.data.result.result_entry.slice(0, 8);
            return reportData;
        } else {
            if (this.title === "Tournament Entries")
              if (windowWidth < '400' && windowWidth > '311') {
                console.log('400 - 311')
                reportData = this.data.entries.entries_entry.slice(0, 7); 
              } else if(windowWidth < '311') {
                console.log(' < 400')
                reportData = this.data.entries.entries_entry.slice(0, 5);
              } else {
                reportData = this.data.entries.entries_entry.slice(0, 10);
              }
            else if (this.title.includes("Draw"))
              reportData = this.data.draw.draw_entry.slice(0, 10);
            else if (
              this.title.includes("Scores") ||
              this.title.includes("Scoreboard")
            )
              if (this.text == 1400 || this.text > 1401) {
                  reportData = this.getScores(7, 7);
              } else if(this.text < 1400  && this.text > 1199){
                  reportData = this.getScores(8, 9);
              } else if (this.text < 1198  && this.text > 1022){
                  reportData = this.getScores(5, 6);
              } else if (this.text < 990){
                // console.log('test 2')
                reportData = this.getScores(5, 6);  
              }
            else if (
              this.title.includes("Final") ||
              this.title.includes("Statistics")
            )
              if (windowWidth < '400' && windowWidth > '311') {
                console.log('400 - 311')
                reportData = this.data.result.result_entry.slice(0, 7); 
              } else if(windowWidth < '311') {
                console.log(' < 400')
                reportData = this.data.result.result_entry.slice(0, 5);
              } else {
                reportData = this.data.result.result_entry.slice(0, 10);
              }
            return reportData;
          }
        }
    },
  },
  watch: {
    Eds(newValue, oldValue) {
      newValue.forEach((value1, key1) => {
        oldValue.forEach((value2, key2) => {
          if (value1.id === value2.id) {
            if (key1 < key2) {
              value1.posChang = "up";
            } else if (key1 > key2) {
              value1.posChang = "down";
            }
          }
        });
      });

      console.log(newValue);
      console.log(newValue);
      window.addEventListener('resize', this.Eds);
      window.addEventListener('resize', this.windowWidth);
      console.log("--" + this.windowWidth)
    },
    immediate: true,
    deep: true,
  },
  created() {
    this.myFunction();
    window.addEventListener('resize', this.myFunction);
  },
  filters: {
    lowercase: function(value) {
      if (!value) {
        return "";
      }
      return value.toLowerCase() + ".svg";
    },
  },
};
</script>

<style scoped>
@media (orientation: landscape) {
  ::v-deep .scoreOnlyCheckOrination:nth-child(5) {
    display: none;
  }
  ::v-deep .scoreOnlyCheckOrination:nth-child(4) {
    display: none;
  }
}
::v-deep td.posnum.scorePos {
  margin-top: 0px;
}
td.posnum.scorePos > span.novalue {
  padding-bottom: 25px;
}
span.spanPos {
  position: relative;
  left: -10px;
}
img.titleistLogo {
  width: 35px;
  position: relative;
  top: 8px;
  left: 10px;
}
span.teeNum {
  position: relative;
  top: 10px;
  color: #000;
  font-weight: 600; 
}
span.holeNum {
  position: relative;
  top: 10px;
  color: #000;
  font-weight: 600;
  left: 12px;
}
.amature {
  position: relative;
  top: 9px;  
}
span.Pname {
  position: relative;
  top: 9px;
}
tr {
  border-bottom: 1px solid #00000033!important;
}
 td > a {
    margin-top: 3px;
    display: block;
}
span.Pname:hover {
  color: #000 !important;
}
a.nameLink{
  color: #000 !important;
}
.catSection {
  padding-top: 16px!important;
  text-align: center!important;
}
.homeEntriesPos {
  margin-top: 8px!important;
}
.homeEntriesStatus {
  vertical-align: middle;
}
a.homeEntriesName {
  margin-top: 0px!important;
}
span.multiCourseSpanTeam {
  margin-top: 10px;
  float: right;
}
span.multiCourseSpan {
  float: right;
  margin-top: -17px;
}
span.multiCourseSpanTeam.B {
  color: #333333;
  font-size: 43px;
  line-height: 0;
  vertical-align: bottom !important;
  margin-top: 17px;
}
span.multiCourseSpanTeam.Y {
  color: #d8db22;
  font-size: 43px;
  line-height: 0;
  vertical-align: bottom !important;
  margin-top: 17px;
}
span.multiCourseSpanTeam.C {
  color: #1E90FF;
  font-size: 43px;
  line-height: 0;
  vertical-align: bottom !important;
  margin-top: 17px;
}
span.multiCourseSpanTeam.R {
  color: #BB0000;
  font-size: 43px;
  line-height: 0;
  vertical-align: bottom !important;
  margin-top: 17px;
}
span.multiCourseSpanTeam.G {
  color: #3c9933;
  font-size: 43px;
  line-height: 0;
  vertical-align: bottom !important;
  margin-top: 17px;
}
span.multiCourseSpanTeam.O {
  color: #e07020;
  font-size: 43px;
  line-height: 0;
  vertical-align: bottom !important;
  margin-top: 17px;
}
span.multiCourseSpan.B {
  color: #333333;
  font-size: 43px;
  line-height: 0;
  vertical-align: bottom !important;
  margin-top: -7px;
}
span.multiCourseSpan.Y {
  color: #d8db22;
  font-size: 43px;
  line-height: 0;
  vertical-align: bottom !important;
  margin-top: -7px;
}
span.multiCourseSpan.C {
  color: #1E90FF;
  font-size: 43px;
  line-height: 0;
  vertical-align: bottom !important;
  margin-top: -7px;
}
span.multiCourseSpan.R {
  color: #BB0000;
  font-size: 43px;
  line-height: 0;
  vertical-align: bottom !important;
  margin-top: -7px;
}
span.multiCourseSpan.G {
  color: #3c9933;
  font-size: 43px;
  line-height: 0;
  vertical-align: bottom !important;
  margin-top: -7px;
}
span.multiCourseSpan.O {
  color: #e07020;
  font-size: 43px;
  line-height: 0;
  vertical-align: bottom !important;
  margin-top: -7px;
}
.B {
  color: #333333;
}
.Y {
  color: #d8db22;
}
.C {
  color: #1E90FF;
}
.R {
  color: #BB0000;
}
.G {
  color: #3c9933;
}
.O {
  color: #e07020;
}
td.posDown {
  position: relative;
  padding-top: 20px;
}
/* td.posDownWinnings {
  margin-top: 10px;
  position: absolute;
} */
span.posDown {
  position: relative;
  top: 8px;
}
td.ParBlack{
  position: relative;
  padding-top: 20px;
  top: -10px;
  text-align: center!important;
}
span.ParBlack{
  position: relative;
  top: 8px;
}
::v-deep span.down.posDown {
  position: relative;
  top: 8px;
}
td.down.posDown {
  position: relative;
  padding-top: 20px;
  top: -10px;
  text-align: center;
}
::v-deep span.up.posDown {
  position: relative;
  top: 8px;
}
td.up.posDown {
  position: relative;
  padding-top: 20px;
  top: -10px;
}
.scorePos {
  margin-left: 0px!important;
}
span.FlagScores {
  margin-top: 6px;
  display: block;
  color: #000;
}
::v-deep button#__BVID__32__BV_toggle_ {
  line-height: 35px;
  padding-bottom: 0;
  height: 40px;
}
td.drawName > a {
  margin-top: 1px;
}
.drawPos {
  max-width: 100% !important;
  text-align: -webkit-center !important;
  margin-top: 0px!important;
  padding-top: 7px!important;
  padding-bottom: 22px!important;
}
.title {
  text-align: center;
  background-color: #00433e;
  color: white;
}
.title > h3 {
  padding-top: 8px;
  margin-bottom: 0px;
  font-size: 24px;
}
.title > p {
  font-size: 16px !important;
  margin-bottom: 0;
}
th {
  position: sticky;
  top: 0;
  /* background-color: #00433e; */
  vertical-align: bottom;
  border-bottom: 0px solid #ddd;
  font-weight: bold;
  color: white;
  font-size: 13px;
  text-transform: capitalize;
  position: sticky;
  position: -webkit-sticky;
  top: -1px;
  /* background: #00433e; */
  color: #ffffff !important;
  text-align: left;
  padding-bottom: 12px;
  padding-top: 12px;
  z-index: 2;
}

.win {
  background-color: #02b2dd !important;
  color: black;
}
.catD {
  color: #7d7d7d;
  font-weight: 300;
}
.drawName {
  font-size: 14px !important;
}
table {
  width: 100%;
}

thead > tr {
  color: white;
}
td:first-child {
  text-align: left;
}
th:first-child {
  text-align: center;
}
th:nth-child(3) {
  text-align: left;
}
td:nth-child(3) {
  text-align: left;
}
.odd {
  background-color: white !important;
}
.even {
  background-color: #dfe1e6 !important;
}
tr:nth-child(even) {
  background-color: #fff;
}
td.posnum {
  padding: 5px;
  padding-top: 4px;
  padding-bottom: 4px;
  display: block;
  max-width: 58px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 8px;
  margin-bottom: 0px;
  color: black;
}
.drawPos {
  max-width: 100% !important;
  text-align: -webkit-center !important;
}
::v-deep td > a {
  /* margin-top: 6px; */
  display: block;
}
td {
  /* padding: 12px; */
  /* padding: 7px; */
  padding: 5px;
  padding-bottom: 0px;
  padding-top: 0px;
  line-height: 1.42857143;
  vertical-align: top;
  border-top: 0px solid #ddd;
  border-right: none !important;
  /* cursor: pointer; */
  text-align: left;
  padding-left: 0px;
  font-size: 14px;
  font-weight: 600;
  color: #000;
}

td.posnum > span {
  padding: 5px;
  display: block;
  max-width: 58px;
}
.noPos > span {
  color: transparent;
  padding: 5px;
  display: block;
  max-width: 58px;
}
.flag {
  width: 30px;
  box-shadow: 0 0 3px #555;
}
.up {
  color: #a52a2a;
}
.down {
  color: #1e90ff;
}
.text-down {
  background: transparent;
  text-shadow: 0 0 0 0 rgba(255, 82, 82, 1);
  animation: glow-red 2s infinite;
  animation-iteration-count: 6;
}

@keyframes glow-red {
  to {
    text-shadow: 0 0 10px rgba(255, 82, 82, 0.7);
  }
}

.text-up {
  background: transparent;
  text-shadow: 0 0 0 0 rgba(51, 217, 178, 1);
  animation: glow-green 2s infinite;
  animation-iteration-count: 6;
}

@keyframes glow-green {
  to {
    text-shadow: 0 0 10px rgba(51, 217, 178, 0.7);
  }
}
.cut {
  padding-top: 6px !important;
  padding-right: 6px !important;
  padding-bottom: 6px !important;
  font-size: 13px;
  vertical-align: middle;
  padding-left: 8px !important;
  background: #aa0003;
  color: white;
  text-align: center!important;
}
::v-deep a:hover{
      color: #00b588!important;
      text-decoration: none;
}
@media only screen and (max-width: 768px) {
  td {
    /* font-size: 12px !important; */
  }
  th {
    font-size: 13px;
  }
  .mobHide {
    display: none;
  }
  #reportCard {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
/* @media only screen and (max-width: 425px) {
  td.up.posDown {
    position: relative;
    padding-top: 0px;
    top: 4px;
  }
  td.down.posDown {
    position: relative;
    padding-top: 0px;
    top: 4px;
  }
} */
@media only screen and (max-width: 400px) {
  ::v-deep td.posnum.scorePos.nsyCSS {
      margin-top: 0;
      top: 0;
  }
  ::v-deep td {
    /* padding: 1.1vw!important; */
  }
  ::v-deep td.up.posDown {
      position: relative;
      padding-top: 20px;
      /* top: 9px; */
  }
  ::v-deep td.down.posDown {
      position: relative;
      padding-top: 20px;
      /* top: 9px; */
  }
  ::v-deep td.posnum {
      padding: 5px;
      padding-top: 4px;
      padding-bottom: 4px;
      display: block;
      max-width: 58px;
      margin-left: auto;
      margin-right: auto;
      margin-top: 8px;
      margin-bottom: 0;
      color: #000;
      position: relative;
      top: 8px;
  }
  ::v-deep td {
      padding: 5px;
      padding-bottom: 0;
      padding-top: 0;
      line-height: 0.7;
      vertical-align: top;
      border-top: 0 solid #ddd;
      border-right: none !important;
      text-align: left;
      padding-left: 0;
      font-size: 14px;
      font-weight: 600;
      color: #000;
  }
  ::v-deep td.posnum.scorePos {
    margin-top: -8px;
  }
}

@media only screen and (max-width: 375px) {
  td.posnum {
      padding: 5px;
      padding-top: 4px;
      padding-bottom: 4px;
      display: block;
      max-width: 58px;
      margin-left: auto;
      margin-right: auto;
      margin-top: 8px;
      margin-bottom: 0;
      color: #000;
      position: relative;
      /* top: -3px; */
      top: 8px;
  }
}
</style>